import type { RouteObject } from "react-router-dom";
import { InventoryLanding } from "./InventoryLanding";

// Child routes of the Inventory app, relative to /cc/inventory. Add migrated
// inventory pages here.
export const InventoryRoutes: RouteObject[] = [
  {
    index: true,
    element: <InventoryLanding />
  }
];
